<admin-panel-configurable [title]="'Variables'">
  <admin-table-standard [items]="variables!">
    <ng-template #header>
      <th class="col-md-4" scope="col">{{ 'pages.channels.view.fields.name' | translate }}</th>
      <th class="col-md-4" scope="col">{{ 'pages.channels.view.fields.type' | translate }}</th>
      <th class="col-md-4" scope="col">{{ 'pages.channels.view.labels.value' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td>{{ item.name }}</td>
      <td>{{ ('common.text.kind.' + item.kind) | translate }}</td>
      <td>{{ item.value | json }}</td>
    </ng-template>
  </admin-table-standard>
</admin-panel-configurable>
